import WithWindowSize from 'Components/WithWindowSize'
import { connect } from 'react-redux'
import {
  loadSearchAutoCompleteData, searchTypingStart,
  updateAlgoliaData,
} from 'Modules/autocomplete/actions'
import { setFilterSearchOpenState } from 'Modules/app/actions'
import { setDiscoveryAreaOpenState } from 'Modules/searchPage/actions'

import { getLocationSearch } from 'Modules/location/selectors'
import { updateSelectedFiltersList } from 'Modules/filters/actions'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'
import { calculateLcaAndSelectedAreas, setSelectedAreas } from 'Modules/searchMap/actions'
import FilterSearch from './FilterSearch'


export default connect(
  state => ({
    areas: state.areasData.areas,
    areasIsFetching: state.areasData.isFetching,
    userIsAuthentificated: state.userData.userIsAuthentificated,
    result: state.searchAutoComplete.algoResult,
    isFetching: state.searchAutoComplete.isFetching,
    selectedItems: state.searchAutoComplete.selectedItems,
    addressIds: state.areaTags.addressId,
    areaFilterTags: state.filters.areaFilterTags,
    lookupFilterTag: state.filters.lookupFilterTag,
    lastSearch: getLocationSearch(state),
    userCurrentArea: state.userDefaults.userCurrentArea,
    isMobile: state.app.isMobile,
    isMobileApp: state.app.isMobileApp,
    isFilterSearchOpen: state.app.isFilterSearchOpen,
    lookups: state.lookups,
    lookupFetching: state.lookups.isFetchingReal,
  }),
  {
    loadAutoComplete: loadSearchAutoCompleteData,
    typingStart: searchTypingStart,
    updateSelectedFiltersList,
    updateAlgoliaData,
    googleAnalyticsEvent,
    setSelectedAreas,
    calculateLcaAndSelectedAreas,
    setFilterSearchOpenState,
    setDiscoveryAreaOpenState,
  },
)(WithWindowSize(FilterSearch))

